import { httpInterceptor } from '../http-interceptor';

export class RobotsService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllRobotsNew',
    SAVE_NEW: 'Machine/saveNewRobot',
    UPDATE: 'Machine/saveNewRobot',
    DELETE: 'Machine/deleteRobot',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdateRobotsMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByRobotId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getRobotMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/saveRobotMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllRobotsByAsstNo',
    GET_SAFETY_CHECKLIST_BY_ROBOT: 'Machine/robotSafetyChecklistByRobot',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateRobotSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deleteRobotSafetyChecklist'
  };

  static async getAllRobots(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewRobot(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

  static async updateRobot(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  static async deleteRobot(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async saveRobotsMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByRobotId(robotId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${robotId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(maintenanceData) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, maintenanceData);
  }

  static async getAllRobotsByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getRobotSafetyChecklistByRobot(robotId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_ROBOT}/${robotId}`,
    );
  }

  static async createRobotSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deleteRobotSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
